(() => {
  'use strict';
  function getOfferState(count, quantity, labels) {
    const remainder = count % 3, completed = Math.floor(count / 3);
    const gained = Math.floor((count + quantity) / 3) - completed;
    const tokens = {__FREE__: String(completed), __QUANTITY__: String(quantity), __LEFT__: String(3 - ((count + quantity) % 3))};
    let title, message;
    if (quantity > 1) {
      title = gained > 1 ? labels.offerBulkMultipleTitle : gained ? labels.offerBulkTitle : labels.offerBulkProgressTitle;
      message = gained ? labels.offerBulk : labels.offerBulkProgress;
      tokens.__FREE__ = String(gained);
    } else if (!count) {
      title = labels.offerStartTitle; message = labels.offerStart;
    } else if (!remainder) {
      title = completed > 1 ? labels.offerCompleteMultipleTitle : labels.offerCompleteTitle;
      message = labels.offerComplete;
    } else if (remainder === 1) {
      title = labels.offerOneTitle; message = labels.offerOne;
    } else {
      title = completed ? labels.offerNextReadyTitle : labels.offerReadyTitle;
      message = labels.offerReady;
    }
    const format = text => String(text || '').replace(/__FREE__|__QUANTITY__|__LEFT__/g, token => tokens[token]);
    return {title: format(title), message: format(message), filled: count && !remainder ? 3 : remainder, ready: gained > 0};
  }
  function boot(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    const variants = JSON.parse($('[data-variants]').textContent), labels = JSON.parse($('[data-product-labels]').textContent);
    const vi = Number(root.dataset.versionIndex), si = Number(root.dataset.sizeIndex);
    const form = $('.fds-form'), id = $('[data-variant-id]'), add = $('[data-add-mode="standard"]');
    let error = $('[data-error]');
    const printFields = ['[data-print-name]', '[data-print-number]', '[data-print-bottom]'];
    const clearFeedback = () => $$('[data-error],[data-custom-error],[data-confirmation],[data-custom-confirmation]').forEach(el => el.hidden = true);
    const printValues = () => ({name: $('[data-print-name]')?.value.trim().toLocaleUpperCase(document.documentElement.lang || 'fr') || '', number: ($('[data-print-number]')?.value || '').replace(/\D/g, '').slice(0,3), bottom: $('[data-print-bottom]')?.value.trim().toLocaleUpperCase(document.documentElement.lang || 'fr') || ''});
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:root.dataset.currency || 'EUR'}).format(n / 100);
    const heading = $('.fds-identity h1'), identityMark = $('.fds-identity-mark');
    const printEligible = root.dataset.printEligible === 'true';
    if (!printEligible) $('.fds-personalize')?.remove();
    function enhanceIdentity() {
      if (!heading || !identityMark || !window.FDClubCrests || identityMark.querySelector('img')) return;
      window.FDClubCrests.decorate(heading);
      const crest = heading.querySelector(':scope > .fd-title-crest');
      if (crest) {
        crest.loading = 'eager';
        identityMark.appendChild(crest);
        identityMark.hidden = false;
        crest.addEventListener('error', () => identityMark.hidden = true, {once:true});
        const club = !crest.classList.contains('fd-title-flag') && window.FDClubCrests.identify(heading.textContent);
        const team = $('[data-identity-team]');
        if (team && club?.name) { team.textContent = club.name; team.hidden = false; }
      }
    }
    enhanceIdentity();
    if (document.readyState !== 'complete') window.addEventListener('load', enhanceIdentity, {once:true});
    window.FDCatalogueJourney?.returnLink($('[data-catalogue-return]'));
    const quantityInput = $('[data-quantity-input]') || form.querySelector('input[name="quantity"]');
    const clampQuantity = value => Math.min(10, Math.max(1, Math.trunc(Number(value)) || 1));
    let variant = null, busy = false, quantity = clampQuantity(quantityInput?.value || 1);
    let offerCount = Number(root.dataset.offerCount || 0);
    const options = () => { const values = []; $$('.fds-option').forEach(f => values[+f.dataset.optionIndex] = f.querySelector('input:checked')?.value); return values; };
    const matches = (v, values, omit = -1) => v.options.every((value, i) => i === omit || !values[i] || value === values[i]);
    function update() {
      let selected = options();
      // A version may be chosen even when the previously selected size is unavailable in it.
      if (si >= 0 && selected[si] && !variants.some(v => v.available && matches(v, selected))) {
        $(`.fds-option[data-option-index="${si}"] input:checked`)?.removeAttribute('checked');
        const checked = $(`.fds-option[data-option-index="${si}"] input:checked`); if (checked) checked.checked = false;
        selected = options();
      }
      const complete = $$('.fds-option').every(f => f.querySelector('input:checked'));
      variant = complete ? variants.find(v => matches(v, selected)) : null;
      const fallback = variants.find(v => v.available && matches(v, selected)) || variants.find(v => matches(v, selected)) || variants[0];
      id.value = variant?.id || ''; id.disabled = !variant?.available;
      $$('.fds-option').forEach(f => {
        const i = +f.dataset.optionIndex;
        f.querySelectorAll('input').forEach(input => {
          input.disabled = !variants.some(v => v.available && v.options[i] === input.value && v.options.every((value, j) => j === i || (i === vi && j === si) || !selected[j] || value === selected[j]));
        });
      });
      const printing = printEligible ? $('[data-printing]') : null, patch = $('[data-patch]');
      const text = printValues(), hasText = Boolean(text.name || text.number || text.bottom);
      root.dataset.printSelected = String(hasText);
      if (printing) printing.checked = hasText;
      const textSummary = $('[data-print-text-summary]');
      if (textSummary) {
        const display = hasText ? text : {name: labels.demoName, number: '00', bottom: labels.demoBottom};
        Object.entries(display).forEach(([key, value]) => { const el = $('[data-print-text-' + key + ']'); if (el) {el.textContent = value; el.hidden = !value;} });
        textSummary.setAttribute('aria-label', labels.textOnly + ' : ' + Object.values(display).filter(Boolean).join(' · '));
      }
      const price = (variant || fallback)?.price || 0;
      const extra = Number(printing?.dataset.price || 0) + (patch?.checked ? Number(patch.dataset.price) : 0);
      $('[data-price]').textContent = money(price); $('[data-total]').textContent = money(price * quantity);
      if ($('[data-custom-total]')) $('[data-custom-total]').textContent = money((price + extra) * quantity);
      if (quantityInput) quantityInput.value = String(quantity);
      $$('[data-quantity-value]').forEach(el => { if (el.matches('input')) el.value = String(quantity); else el.textContent = String(quantity); });
      $$('[data-quantity-minus]').forEach(button => button.disabled = busy || quantity <= 1);
      $$('[data-quantity-plus]').forEach(button => button.disabled = busy || quantity >= 10);
      const printingSummary = $('[data-printing-summary]'), patchSummary = $('[data-patch-summary]');
      if (printingSummary) {
        printingSummary.textContent = printing?.checked ? ['[data-print-name]','[data-print-number]','[data-print-bottom]'].map(s => $(s)?.value.trim()).filter(Boolean).join(' / ') || labels.printingCustom || labels.printing : '';
        printingSummary.hidden = !printing?.checked;
      }
      if (patchSummary) patchSummary.textContent = patch?.checked ? labels.optionAdded || labels.patch : labels.optional || 'Optionnel';
      $$('[data-offer-average]').forEach(el => el.textContent = money(Math.round(price * 2 / 3)));
      $$('[data-offer-total]').forEach(el => el.textContent = money(price * 2));
      $$('[data-offer-context]').forEach(el => el.textContent = (labels.offerPriceContext || '').replace('__PRICE__', money(price)));
      renderOfferProgress();
      const needsSize = si >= 0 && !selected[si];
      const summary = selected.filter(Boolean).map(x => /^(standard|fan)$/i.test(x) ? 'Fan' : /^(version pro|player)$/i.test(x) ? 'Player' : x);
      if (needsSize) summary.push(labels.chooseSize);
      if (printing?.checked) summary.push(labels.printing + ' ' + printFields.map(s => $(s)?.value.trim()).filter(Boolean).join(' / ') + ' (+' + money(+printing.dataset.price) + ')');
      if (patch?.checked) summary.push(labels.patch + ' (+' + money(+patch.dataset.price) + ')');
      $('[data-selection-summary]').textContent = summary.join(' · ');
      $('[data-availability]').textContent = fallback?.available ? labels.available : labels.unavailable;
      const canChoose = !complete && variants.some(v => v.available && matches(v, selected));
      const cannotBuy = busy || (!variant?.available && !canChoose);
      $$('[data-add-mode]').forEach(button => button.disabled = cannotBuy);
      const customLabel = $('[data-custom-add-label]');
      if (customLabel) customLabel.textContent = busy ? labels.adding : !variant?.available && !canChoose ? labels.unavailable : labels.addCustom;
      const customSelection = $('[data-custom-selection]');
      if (customSelection) customSelection.textContent = selected.filter(Boolean).map(value => /^(standard|fan)$/i.test(value) ? 'Fan' : /^(version pro|player)$/i.test(value) ? 'Player' : value).join(' · ') + (needsSize ? (selected.filter(Boolean).length ? ' · ' : '') + labels.chooseSize : '') + ' · ' + labels.quantityLabel + ' ' + quantity;
      $('[data-add-label]').textContent = busy ? labels.adding : needsSize ? labels.chooseSize : !complete ? labels.chooseOptions : variant?.available ? labels.add : labels.unavailable;
      $$('[data-size-chart]').forEach(chart => chart.hidden = Boolean(chart.dataset.sizeVersion && chart.dataset.sizeVersion.toLowerCase() !== selected[vi]?.toLowerCase()));
      if (vi >= 0) {
        $$('[data-comparison-version]').forEach(card => {
          const candidates = variants.filter(v => v.options[vi] === card.dataset.comparisonVersion && matches(v, selected, vi));
          const prices = candidates.map(v => v.price), lowest = Math.min(...prices), highest = Math.max(...prices);
          card.querySelector('[data-comparison-price]').textContent = prices.length ? (lowest !== highest ? labels.fromPrice + ' ' : '') + money(lowest) : labels.unavailable;
          const fanPrices = variants.filter(v => /^(fan|standard)$/i.test(v.options[vi]) && matches(v, selected, vi)).map(v => v.price), base = Math.min(...fanPrices);
          card.querySelector('[data-comparison-difference]').textContent = prices.length && fanPrices.length && lowest > base ? labels.priceDifference.replace('__PRICE__', money(lowest-base)) : '';
          card.classList.toggle('is-selected', card.dataset.comparisonVersion === selected[vi]);
        });
        const fan = variants.find(v => v.available && /^(fan|standard)$/i.test(v.options[vi]) && matches(v, selected, vi));
        $$('.fds-version label').forEach(label => {
          const field = label.querySelector('[data-upgrade-price]'); if (!field) return;
          const player = variants.find(v => v.available && v.options[vi] === label.querySelector('input').value && matches(v, selected, vi));
          field.textContent = player && fan && player.price > fan.price ? '+' + money(player.price - fan.price) : '';
        });
      }
    }
    function changeQuantity(value) {
      if (busy) return;
      quantity = clampQuantity(value);
      clearFeedback();
      update();
    }
    $$('[data-quantity-minus]').forEach(button => button.addEventListener('click', () => changeQuantity(quantity - 1)));
    $$('[data-quantity-plus]').forEach(button => button.addEventListener('click', () => changeQuantity(quantity + 1)));
    quantityInput?.addEventListener('change', () => changeQuantity(quantityInput.value));
    $$('.fds-option input').forEach(input => input.addEventListener('change', () => {
      clearFeedback(); update();
      const url = new URL(location.href); if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant'); history.replaceState(history.state, '', url);
      syncGalleryVersion();
      const visible = activeSlides();
      const idx = visible.findIndex(x => String(x.dataset.mediaId) === String(variant?.featured_media?.id));
      show(idx >= 0 ? idx : 0);
    }));
    $('[data-patch]')?.addEventListener('change', () => { clearFeedback(); update(); });
    root.addEventListener('fd:printing-state', update);
    printFields.forEach(selector => $(selector)?.addEventListener('input', () => {
      if (selector.includes('number')) $(selector).value = $(selector).value.replace(/\D/g, '').slice(0,3);
      clearFeedback(); update();
    }));
    printFields.forEach(selector => $(selector)?.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); $('[data-add-mode="personalized"]')?.click(); }
    }));
    $('[data-return-options]')?.addEventListener('click', () => {
      const option = $('.fds-size') || $('.fds-option');
      option?.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      option?.querySelector('input:checked, input:not(:disabled)')?.focus({preventScroll:true});
    });
    const slides = $('[data-slides]'), allSlides = $$('.fds-slide'), allThumbs = $$('[data-thumb]'), allDots = $$('[data-gallery-dot]'); let current = 0;
    const galleryVersion = () => {
      const value = vi >= 0 ? options()[vi] : '';
      if (/player|pro/i.test(value || '')) return 'player';
      if (vi < 0 && root.dataset.playerProduct === 'true') return 'player';
      return 'fan';
    };
    function activeSlides() {
      const key = galleryVersion();
      const requested = allSlides.filter(slide => (slide.dataset.mediaVersion || 'fan') === key);
      return requested;
    }
    function syncGalleryVersion() {
      const active = activeSlides(), visible = new Set(active);
      allSlides.forEach(slide => { slide.hidden = !visible.has(slide); });
      allThumbs.forEach((thumb, rawIndex) => { thumb.hidden = !visible.has(allSlides[rawIndex]); });
      allDots.forEach((dot, index) => {
        dot.hidden = index >= Math.min(active.length, 8);
        dot.dataset.activeGalleryIndex = String(index);
      });
      const empty = active.length === 0;
      const placeholder = $('[data-gallery-placeholder]'); if (placeholder) placeholder.hidden = !empty;
      const zoom = $('[data-zoom]'); if (zoom) zoom.hidden = empty;
      const previous = $('[data-gallery-prev]'), next = $('[data-gallery-next]');
      if (previous) previous.hidden = empty || active.length < 2;
      if (next) next.hidden = empty || active.length < 2;
      current = Math.max(0, Math.min(current, active.length - 1));
      if (empty) {
        slides.scrollLeft = 0;
        const count = $('[data-image-count]'); if (count) count.textContent = '00 / 00';
      }
    }
    function syncGallery() {
      const active = activeSlides(), selected = active[current], rawIndex = allSlides.indexOf(selected);
      allThumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-pressed', String(index === rawIndex));
        if (index !== rawIndex || thumb.hidden) return;
        const strip = thumb.parentElement, frame = strip.getBoundingClientRect(), box = thumb.getBoundingClientRect();
        if (strip.scrollHeight > strip.clientHeight + 1) {
          if (box.top < frame.top) strip.scrollTop += box.top - frame.top;
          else if (box.bottom > frame.bottom) strip.scrollTop += box.bottom - frame.bottom;
        }
        if (strip.scrollWidth > strip.clientWidth + 1) {
          if (box.left < frame.left) strip.scrollLeft += box.left - frame.left;
          else if (box.right > frame.right) strip.scrollLeft += box.right - frame.right;
        }
      });
      allDots.forEach((dot, index) => dot.setAttribute('aria-current', String(!dot.hidden && index === current)));
      const count = $('[data-image-count]');
      if (count) count.textContent = active.length ? String(current + 1).padStart(2,'0') + ' / ' + String(active.length).padStart(2,'0') : '00 / 00';
    }
    function show(i, instant = false) {
      const active = activeSlides();
      if (!active.length) { current = 0; syncGallery(); return; }
      current = (i + active.length) % active.length;
      slides.scrollTo({left: current * slides.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      syncGallery();
    }
    slides.addEventListener('scroll', () => {
      const active = activeSlides(); if (!active.length) return;
      current = Math.max(0, Math.min(active.length - 1, Math.round(slides.scrollLeft / (slides.clientWidth || 1))));
      syncGallery();
    }, {passive:true});
    allThumbs.forEach((thumb, rawIndex) => thumb.addEventListener('click', () => {
      const index = activeSlides().indexOf(allSlides[rawIndex]); if (index >= 0) show(index);
    }));
    allDots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.activeGalleryIndex || 0))));
    $('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    $('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    slides.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); show(current + (e.key === 'ArrowRight' ? 1 : -1));} });
    const dialog = $('[data-lightbox]'); $('[data-zoom]')?.addEventListener('click', () => {const src = activeSlides()[current]?.querySelector('img'); if (!src) return; $('[data-zoom-image]').src = src.currentSrc || src.src; dialog.showModal();});
    $('[data-close-zoom]').addEventListener('click', () => dialog.close()); dialog.addEventListener('click', e => {if (e.target === dialog) dialog.close();});
    $$('a[href^="#fds-"]').forEach(link => link.addEventListener('click', () => { const detail = root.querySelector(link.getAttribute('href')); if (detail) detail.open = true; }));
    form.addEventListener('submit', async e => {
      e.preventDefault(); if (busy) return; clearFeedback();
      const personalized = e.submitter?.dataset.addMode === 'personalized';
      error = personalized ? $('[data-custom-error]') : $('[data-error]');
      if (!variant?.available) { error.textContent = si >= 0 && !options()[si] ? labels.chooseSize : labels.chooseOptions; error.hidden = false; const missing = $$('.fds-option').find(f => !f.querySelector('input:checked')); const input = missing?.querySelector('input:not(:disabled)'); missing?.scrollIntoView({block:'center',behavior:'smooth'}); input?.focus({preventScroll:true}); return; }
      const props = {}, addons = [], printing = printEligible ? $('[data-printing]') : null, patch = $('[data-patch]');
      const group = 'fd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,7);
      if (personalized && printing) {
        const {name, number, bottom} = printValues();
        if (!name && !number && !bottom) { error.textContent = labels.printingEmpty || labels.printingError; error.hidden = false; $('[data-print-name]').focus(); return; }
        props.Flocage = [name, number, bottom ? labels.bottomLabel + ' : ' + bottom : ''].filter(Boolean).join(' / ');
        if (name) props['Nom'] = name;
        if (number) props['Numéro'] = number;
        if (bottom) props['Texte en bas du dos'] = bottom;
        addons.push({id:Number(printing.dataset.variant),quantity,properties:{'Pour le maillot':root.querySelector('h1').textContent,...props,_fd_group:group}});
        if (patch?.checked) { props.Patch = 'Oui'; addons.push({id:Number(patch.dataset.variant),quantity,properties:{'Pour le maillot':root.querySelector('h1').textContent,_fd_group:group}}); }
      }
      if (addons.length) props._fd_group = group;
      props._fd_offer_eligible = root.dataset.offerEligible === 'true' ? '1' : '0';
      busy = true; update();
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity,properties:props},...addons]})});
        const result = await response.json(); if (!response.ok) throw new Error(result.description || labels.addError);
        $(personalized ? '[data-custom-confirmation]' : '[data-confirmation]').hidden = false; document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); document.dispatchEvent(new CustomEvent('fd:cart-added',{detail:{items:result.items || [result]}}));
      } catch (err) { error.textContent = err.message || labels.networkError; error.hidden = false; }
      finally { busy = false; update(); }
    });
    function renderOfferProgress() {
      const progress = $('[data-pdp-offer-progress]');
      if (!progress) return;
      progress.hidden = offerCount === null;
      if (offerCount === null) return;
      const state = getOfferState(offerCount, quantity, labels);
      const title = $('[data-pdp-offer-title]'), message = $('[data-pdp-offer-message]');
      if (title && title.textContent !== state.title) title.textContent = state.title;
      if (message && message.textContent !== state.message) message.textContent = state.message;
      progress.classList.toggle('is-ready', state.ready);
      $$('[data-pdp-offer-step]').forEach(el => el.classList.toggle('is-filled', Number(el.dataset.pdpOfferStep) <= state.filled));
    }
    const productEligibility = new Map();
    let progressRequest = 0;
    async function refreshOfferProgress() {
      if (!$('[data-pdp-offer-progress]') && !$('[data-product-cart-count]')) return;
      const request = ++progressRequest;
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('cart unavailable');
        const cart = await response.json();
        if (request !== progressRequest) return;
        $$('[data-product-cart-count]').forEach(badge => { badge.textContent = String(cart.item_count); badge.hidden = !cart.item_count; });
        if (!$('[data-pdp-offer-progress]')) return;
        const eligible = await Promise.all(cart.items.map(async item => {
          if (['flocage-personnalise', 'patch-officiel'].includes(item.handle)) return false;
          if (item.properties?._fd_offer_eligible != null) return item.properties._fd_offer_eligible === '1';
          if (!productEligibility.has(item.handle)) productEligibility.set(item.handle, fetch(shopRoot + 'products/' + encodeURIComponent(item.handle) + '.js', {headers:{Accept:'application/json'}}).then(async res => {
            if (!res.ok) throw new Error('product unavailable');
            const product = await res.json();
            const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(s => s.trim());
            return tags.includes('Maillot individuel') || tags.includes('Ensemble maillot') || tags.includes('Enfant Ensemble');
          }));
          return productEligibility.get(item.handle);
        }));
        if (request !== progressRequest) return;
        offerCount = cart.items.reduce((sum, item, index) => sum + (eligible[index] ? item.quantity : 0), 0);
        renderOfferProgress();
      } catch (_) {
        if (request !== progressRequest) return;
        productEligibility.clear();
        offerCount = null;
        renderOfferProgress();
      }
    }
    let offerRefreshTimer;
    function scheduleOfferProgress() {
      ++progressRequest;
      clearTimeout(offerRefreshTimer);
      offerRefreshTimer = setTimeout(refreshOfferProgress, 80);
    }
    ['fd:cart-added', 'cart:updated', 'cart:refresh', 'cart:update'].forEach(event => document.addEventListener(event, scheduleOfferProgress));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleOfferProgress(); });
    window.addEventListener('pageshow', scheduleOfferProgress);
    refreshOfferProgress();
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) { const reveal = new IntersectionObserver(entries => entries.forEach(entry => {if (entry.isIntersecting) {entry.target.classList.add('fds-visible'); reveal.unobserve(entry.target);}}),{threshold:.12}); $$('[data-fds-reveal]').forEach(el => {el.classList.add('fds-reveal-ready'); reveal.observe(el);}); }
    update(); syncGalleryVersion(); const initial = activeSlides().findIndex(el => String(el.dataset.mediaId) === String(variant?.featured_media?.id)); show(initial >= 0 ? initial : 0, true);
  }
  function init() {document.querySelectorAll('[data-fd-studio]').forEach(boot);}
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',init) : init(); document.addEventListener('shopify:section:load',init);
})();

